var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgProbabilityHail01 = function SvgProbabilityHail01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "data-name": "Layer 1",
    viewBox: "0 0 631.96 500.84",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "probability_hail-01_svg2__a",
    x1: 19.37,
    x2: 446.37,
    y1: 278.14,
    y2: -19.86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#probability_hail-01_svg2__a",
    id: "probability_hail-01_svg2__b",
    x1: 68.41,
    x2: 495.41,
    y1: 348.41,
    y2: 50.41
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#probability_hail-01_svg2__a",
    id: "probability_hail-01_svg2__c",
    x1: -23.59,
    x2: 403.41,
    y1: 216.59,
    y2: -81.41
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#probability_hail-01_svg2__a",
    id: "probability_hail-01_svg2__d",
    x1: 167.04,
    x2: 594.04,
    y1: 489.74,
    y2: 191.74
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#probability_hail-01_svg2__a",
    id: "probability_hail-01_svg2__e",
    x1: 252.39,
    x2: 679.39,
    y1: 612.03,
    y2: 314.03
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#probability_hail-01_svg2__a",
    id: "probability_hail-01_svg2__f",
    x1: 140.2,
    x2: 567.2,
    y1: 451.28,
    y2: 153.28
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#probability_hail-01_svg2__a",
    id: "probability_hail-01_svg2__g",
    x1: 223.47,
    x2: 650.47,
    y1: 570.59,
    y2: 272.59
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#probability_hail-01_svg2__a",
    id: "probability_hail-01_svg2__h",
    x1: 142.14,
    x2: 569.14,
    y1: 454.06,
    y2: 156.06
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#probability_hail-01_svg2__a",
    id: "probability_hail-01_svg2__i",
    x1: 156.73,
    x2: 583.73,
    y1: 474.96,
    y2: 176.96
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#probability_hail-01_svg2__a",
    id: "probability_hail-01_svg2__j",
    x1: 267.53,
    x2: 694.53,
    y1: 633.73,
    y2: 335.73
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#probability_hail-01_svg2__a",
    id: "probability_hail-01_svg2__k",
    x1: 242.2,
    x2: 669.2,
    y1: 597.43,
    y2: 299.43
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#probability_hail-01_svg2__a",
    id: "probability_hail-01_svg2__l",
    x1: 204.49,
    x2: 631.49,
    y1: 543.39,
    y2: 245.39
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#probability_hail-01_svg2__a",
    id: "probability_hail-01_svg2__m",
    x1: 211.06,
    x2: 638.06,
    y1: 552.81,
    y2: 254.81
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#probability_hail-01_svg2__a",
    id: "probability_hail-01_svg2__n",
    x1: 186.97,
    x2: 613.97,
    y1: 518.29,
    y2: 220.29
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M171.78 0C76.91 0 0 76.91 0 171.78s76.91 171.78 171.78 171.78 171.78-76.91 171.78-171.78S266.65 0 171.78 0M75.39 143.18q-6.15-10.2-6.15-22.8c0-12.6 2.07-16.3 6.23-23.1q6.225-10.2 16.5-16.05c6.85-3.9 14.32-5.85 22.42-5.85s15.7 2 22.5 6 12.23 9.4 16.27 16.2c4.05 6.8 6.08 14.4 6.08 22.8s-2.08 16.15-6.23 22.95-9.63 12.15-16.42 16.05q-10.2 5.85-22.2 5.85c-12 0-15.73-1.97-22.57-5.92-6.85-3.95-12.33-9.32-16.43-16.13m55.5 141h-42.3l121.2-210h42.3zm134.47-23.4c-4.05 6.8-9.5 12.23-16.35 16.28s-14.43 6.08-22.73 6.08-15.85-2.07-22.65-6.23q-10.2-6.225-16.2-16.5c-4-6.85-6-14.22-6-22.12 0-8.6 2.07-16.3 6.22-23.1s9.65-12.17 16.5-16.12 14.22-5.92 22.12-5.92q12.9 0 23.1 6.3c6.8 4.2 12.17 9.73 16.12 16.58s5.93 14.28 5.93 22.27-2.03 15.7-6.08 22.5Z",
    style: {
      fill: "url(#probability_hail-01_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.29 218.18q-8.1 0-13.95 5.85t-5.85 14.25c0 8.4 1.95 10.05 5.85 13.95q5.85 5.85 13.95 5.85c8.1 0 10.35-1.95 14.25-5.85q5.85-5.85 5.85-13.95c0-8.1-1.95-10.35-5.85-14.25q-5.85-5.85-14.25-5.85",
    style: {
      fill: "url(#probability_hail-01_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.39 140.18c5.4 0 10.05-1.92 13.95-5.77s5.85-8.52 5.85-14.02-1.95-10.3-5.85-14.1q-5.85-5.7-13.95-5.7c-8.1 0-10.23 1.9-14.17 5.7-3.95 3.8-5.93 8.5-5.93 14.1s1.97 10.18 5.93 14.02c3.95 3.85 8.67 5.77 14.17 5.77",
    style: {
      fill: "url(#probability_hail-01_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.57 420.28c2.12 0 4.14-.97 5.46-2.63l30.18-37.81a6.99 6.99 0 0 0-1.1-9.82 6.99 6.99 0 0 0-9.82 1.1l-30.18 37.81c-1.67 2.1-2 4.97-.83 7.39a6.98 6.98 0 0 0 6.29 3.96",
    style: {
      fill: "url(#probability_hail-01_svg2__d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M581.08 372.36a6.99 6.99 0 0 0-9.82 1.1l-28.3 35.46c-2.41 3.01-1.91 7.41 1.1 9.82a7 7 0 0 0 9.82-1.1l28.31-35.46a7 7 0 0 0-1.1-9.82Z",
    style: {
      fill: "url(#probability_hail-01_svg2__e)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.83 347.22c-2.51-.36-5.01.66-6.55 2.67l-21.36 26.76a6.977 6.977 0 1 0 10.9 8.71l21.37-26.76a6.99 6.99 0 0 0 1.16-6.97 6.99 6.99 0 0 0-5.52-4.41",
    style: {
      fill: "url(#probability_hail-01_svg2__f)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.11 388c11.96 0 21.65-9.69 21.65-21.65s-9.69-21.65-21.65-21.65-21.65 9.69-21.65 21.65c.02 11.95 9.7 21.63 21.65 21.65m0-29.32c4.24 0 7.68 3.44 7.68 7.68s-3.44 7.68-7.68 7.68-7.68-3.44-7.68-7.68 3.44-7.67 7.68-7.68",
    style: {
      fill: "url(#probability_hail-01_svg2__g)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M621.46 215.31a77.66 77.66 0 0 0-67.72-38.67 76.2 76.2 0 0 0-26.56 4.74c-13.4-39.99-47.75-69.35-89.34-76.36-32.72-5.52-65.74 3.5-90.88 23.86 2.22 4.27 4.23 8.66 6.02 13.16 22.39-19.49 52.71-28.39 82.84-23.2 38.84 6.68 70.17 35.49 80.07 73.64 3.22 15.98 2.7 32.49-1.52 48.23-1.17 3.64.81 7.54 4.43 8.76 3.63 1.22 7.55-.71 8.82-4.32 4.59-16.26 5.59-33.33 2.9-50.01a62.6 62.6 0 0 1 23.22-4.53 63.7 63.7 0 0 1 55.58 31.7 63.69 63.69 0 0 1 0 63.98 63.69 63.69 0 0 1-55.58 31.7s-262.09 0-262.09 0c-10.39 6-21.61 10.73-33.44 13.97h295.54c27.88.2 53.72-14.56 67.72-38.67s14-53.87 0-77.98Z",
    style: {
      fill: "url(#probability_hail-01_svg2__h)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.62 400.97c-15.08 0-27.31 12.22-27.31 27.31 0 15.08 12.24 27.31 27.32 27.3 15.08 0 27.3-12.24 27.3-27.32-.03-15.07-12.24-27.27-27.3-27.29Zm0 40.64c-7.36 0-13.33-5.96-13.34-13.32 0-7.36 5.96-13.34 13.32-13.35 7.36 0 13.34 5.95 13.35 13.32 0 7.37-5.97 13.34-13.33 13.35",
    style: {
      fill: "url(#probability_hail-01_svg2__i)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.24 436.35c-15.08 0-27.3 12.22-27.3 27.3s12.22 27.3 27.3 27.3 27.3-12.22 27.3-27.3c-.02-15.07-12.23-27.29-27.3-27.3m0 40.64c-7.36 0-13.33-5.97-13.33-13.33s5.97-13.33 13.33-13.33 13.33 5.97 13.33 13.33-5.97 13.33-13.33 13.33",
    style: {
      fill: "url(#probability_hail-01_svg2__j)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.27 398.48a6.99 6.99 0 0 0-9.82 1.1l-71.77 89.9a7 7 0 0 0 1.1 9.82 6.99 6.99 0 0 0 9.82-1.1l71.77-89.91a7 7 0 0 0-1.1-9.82Z",
    style: {
      fill: "url(#probability_hail-01_svg2__k)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.75 430.68c-18.21 0-32.96 14.76-32.97 32.96 0 18.21 14.76 32.97 32.96 32.97s32.96-14.76 32.97-32.96c-.02-18.2-14.77-32.95-32.96-32.97m0 51.97c-10.49 0-19-8.51-19-18.99s8.51-18.99 19-18.99 18.99 8.5 18.99 18.99c-.01 10.49-8.51 18.98-18.99 18.99",
    style: {
      fill: "url(#probability_hail-01_svg2__l)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.09 358.61c2.4-3.01 1.91-7.41-1.1-9.82a7 7 0 0 0-9.82 1.1l-75.31 94.33a6.994 6.994 0 1 0 10.93 8.73l75.31-94.34Z",
    style: {
      fill: "url(#probability_hail-01_svg2__m)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.56 366.85a6.99 6.99 0 0 0-1.1-9.82 6.99 6.99 0 0 0-9.82 1.1l-40.55 50.81c-2.41 3.01-1.91 7.41 1.1 9.82s7.41 1.91 9.82-1.1l40.56-50.8Z",
    style: {
      fill: "url(#probability_hail-01_svg2__n)"
    }
  }));
};
export default SvgProbabilityHail01;